<template>
    <div class="gift-record-page flex row">
        <UserListSidebar :selected-user="selectedUser" title="用户列表" @select-user="selectUser" />

        <!-- 礼物记录区域 -->
        <div class="gift-record-section flex1 bg-white br-8 mg-10 pd-15" v-if="selectedUser">
            <!-- Tab切换区域 -->
            <div class="section-header mb-15">
                <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="gift-record-tabs">
                    <el-tab-pane label="记录列表" name="list">
                        <span slot="label" class="flex row center middle">
                            <i class="el-icon-s-data mr-5"></i>
                            记录列表
                        </span>
                    </el-tab-pane>
                    <el-tab-pane label="数据分析" name="analysis">
                        <span slot="label" class="flex row center middle">
                            <i class="el-icon-pie-chart mr-5"></i>
                            数据分析
                        </span>
                    </el-tab-pane>
                </el-tabs>
            </div>

            <!-- 礼物记录列表视图 -->
            <div v-if="activeTab === 'list'" class="gift-record-list flex1 scroll-y">
                <div v-if="giftRecordLoading" class="loading-container flex col middle center h-200">
                    <img src="@/assets/loading.png" alt="" class="w-40 h-40 rotate360">
                    <span class="color-gray fs-14 mt-10">加载中...</span>
                </div>

                <div v-else-if="giftRecordList.length === 0" class="empty-container flex col middle center h-200">
                    <i class="el-icon-present fs-48 color-lightgray"></i>
                    <span class="color-gray fs-14 mt-10">暂无礼物记录</span>
                </div>

                <div v-else class="gift-cards-container">
                    <div v-for="(record, index) in giftRecordList" :key="index"
                        class="gift-card bg-white br-8 pd-20 mb-15 border border-lightgray2">
                        <!-- 发送者信息头部 -->
                        <div class="card-header flex row middle between mb-15">
                            <div class="sender-info flex row middle">
                                <img :src="record.userDetail?.avatar_small || require('@/assets/profile.png')" alt=""
                                    class="w-32 h-32 round cover mr-10">
                                <span class="fs-14 color-black bold">{{ record.userDetail?.name || '未知用户' }}</span>
                                <span class="fs-12 color-gray ml-8">sent you a gift</span>
                            </div>
                            <div class="card-actions flex row middle pointer">
                                <!-- <img src="@/assets/svg/pd-email.svg" class="w-20 h-20 action-icon"
                                    @click.stop="toChat(record, 'email')" alt="发送邮件" title="发送邮件"> -->
                                <img src="@/assets/svg/pd-msg.svg" class="w-20 h-20 action-icon ml-8"
                                    @click.stop="toChat(record, 'chat')" alt="开始聊天" title="开始聊天">
                            </div>
                        </div>

                        <!-- 礼物展示区域 -->
                        <div class="gift-display flex col middle center">
                            <img :src="record.gift?.imageSrc || require('@/assets/profile.png')" alt=""
                                class="w-100 h-100 mb-15">
                            <div class="gift-cost fs-20 color-talkytimes bold mb-10">{{ record.gift?.cost || 0 }}</div>
                        </div>

                        <!-- 礼物消息 -->
                        <div v-if="record.message" class="gift-message fs-14 color-gray2 text-center mb-10 br-6">
                            {{ record.message }}
                        </div>
                        <div v-else class="gift-message fs-14 color-gray text-center mb-10">
                            With no gift message
                        </div>

                        <!-- 时间信息 -->
                        <div class="gift-time fs-12 color-gray text-center">{{ formatTime(record.dateSent) }}</div>
                    </div>
                </div>
            </div>

            <!-- 数据分析视图 -->
            <div v-else-if="activeTab === 'analysis'" class="gift-analysis flex1 scroll-y">
                <!-- 筛选器 -->
                <div class="filter-section mb-20 pd-15 bg-lightgray4 br-6">
                    <div class="flex row middle between mb-10">
                        <span class="fs-14 color-black bold">时间筛选</span>
                        <el-button type="primary" size="mini" @click="filterGiftData" :loading="analysisLoading">
                            查询
                        </el-button>
                    </div>
                    <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="onDateRangeChange"
                        style="width: 100%;" clearable>
                    </el-date-picker>
                </div>

                <!-- 统计卡片 -->
                <div class="stats-section flex row between mb-20">
                    <div class="stat-card flex1 text-center pd-15 bg-lightbule2 br-6 mr-10">
                        <div class="stat-number fs-24 color-talkytimes bold">{{ analysisData.totalGifts }}</div>
                        <div class="stat-label fs-12 color-gray">总礼物数量</div>
                    </div>
                    <div class="stat-card flex1 text-center pd-15 bg-lightbule2 br-6 mr-10">
                        <div class="stat-number fs-24 color-talkytimes bold">{{ analysisData.totalCredits }}</div>
                        <div class="stat-label fs-12 color-gray">总积分</div>
                    </div>
                    <div class="stat-card flex1 text-center pd-15 bg-lightbule2 br-6">
                        <div class="stat-number fs-24 color-talkytimes bold">{{ analysisData.totalUsers }}</div>
                        <div class="stat-label fs-12 color-gray">送礼用户数</div>
                    </div>
                </div>

                <!-- 数据表格 -->
                <div class="table-section">
                    <el-table :data="analysisData.filteredData" style="width: 100%"
                        :header-cell-style="{ backgroundColor: '#f0f8ff', color: '#333' }" v-loading="analysisLoading">
                        <el-table-column prop="gift.name" label="礼物名称" min-width="120">
                            <template slot-scope="scope">
                                <div class="flex row middle">
                                    <img :src="scope.row.gift?.imageSrc" :alt="scope.row.gift?.name"
                                        class="w-32 h-32 round cover mr-8">
                                    <span class="fs-14">{{ scope.row.gift?.name }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="dateSent" label="发送时间" min-width="150" sortable>
                            <template slot-scope="scope">
                                <span class="fs-12">{{ formatGiftTime(scope.row.dateSent) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="userDetail.name" label="发送者" min-width="100">
                            <template slot-scope="scope">
                                <div class="flex row middle">
                                    <img :src="scope.row.userDetail?.avatar_small || require('@/assets/profile.png')"
                                        class="w-24 h-24 round cover mr-6">
                                    <span class="fs-12">{{ scope.row.userDetail?.name || '未知用户' }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="gift.cost" label="积分" min-width="80" sortable>
                            <template slot-scope="scope">
                                <span class="fs-14 color-talkytimes bold">{{ scope.row.gift?.cost }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>

        <!-- 未选择用户时的提示 -->
        <div v-else class="empty-selection flex1 flex col middle center bg-white br-8 mg-10 pd-15">
            <i class="el-icon-user-solid fs-64 color-lightgray mb-20"></i>
            <h3 class="fs-20 color-gray mb-10">请选择一个用户</h3>
            <p class="fs-14 color-gray text-center">从左侧用户列表中选择一个用户<br>查看该用户的礼物记录</p>
        </div>
    </div>
</template>

<script>
import { getReceivedList, getReceivedStatistics } from '@/api/talkytimes/user'
import store from '@/store'
import { formatTime } from '@/utils/talkytimesFormat'
import UserListSidebar from '@/components/UserListSidebar.vue'

export default {
    name: 'GiftRecord',
    components: {
        UserListSidebar
    },
    data() {
        return {
            // 用户列表相关
            selectedUser: null,

            // 礼物记录相关
            giftRecordList: [],
            giftRecordLoading: false,

            // 分析相关
            activeTab: 'list', // 当前激活的tab
            dateRange: null,
            analysisData: {
                totalGifts: 0,
                totalCredits: 0,
                totalUsers: 0,
                filteredData: []
            },
            analysisLoading: false
        }
    },
    methods: {
        formatTime,

        // 移除 getUserList 方法，改为使用 UserListSidebar 组件自动获取数据

        // 刷新用户列表
        refreshUserList() {
            // 移除重复的数据获取
        },

        // 选择用户
        selectUser(user) {
            this.selectedUser = user
            // 设置当前用户的token
            localStorage.setItem('activeUser', JSON.stringify(user))
            // 获取该用户的礼物记录
            this.getGiftRecordList()
            // 重置为记录列表tab
            this.activeTab = 'list'
            this.resetAnalysisData()
        },

        // 处理tab切换
        handleTabClick(tab) {
            if (tab.name === 'analysis') {
                // 切换到数据分析tab时，加载分析数据
                this.filterGiftData()
            }
        },

        // 获取礼物记录
        async getGiftRecordList() {
            if (!this.selectedUser) return

            this.giftRecordLoading = true
            try {
                const res = await getReceivedList()
                if (res && res.length > 0) {
                    const recordsWithUserInfo = await store.dispatch('userInfo/matchChatListUserInfo', {
                        chatList: res,
                        userIdField: 'idUserFrom',
                        platformUserIdField: 'idUserTo'
                    })
                    this.giftRecordList = recordsWithUserInfo
                } else {
                    this.giftRecordList = []
                }
            } catch (error) {
                console.error('获取礼物记录失败:', error)
                this.$message.error('获取礼物记录失败')
                this.giftRecordList = []
            } finally {
                this.giftRecordLoading = false
            }
        },

        // 日期范围变化
        onDateRangeChange() {
            if (this.activeTab === 'analysis') {
                this.filterGiftData()
            }
        },

        // 筛选礼物数据
        async filterGiftData() {
            if (!this.selectedUser) return

            this.analysisLoading = true
            try {
                let params = {}
                if (this.dateRange && this.dateRange.length === 2) {
                    params = {
                        dateFrom: this.formatDateToISO(this.dateRange[0]),
                        dateTo: this.formatEndDateToISO(this.dateRange[1])
                    }
                }

                const giftRecords = await getReceivedStatistics(params)

                if (giftRecords && giftRecords.length > 0) {
                    const recordsWithUserInfo = await store.dispatch('userInfo/matchChatListUserInfo', {
                        chatList: giftRecords,
                        userIdField: 'idUserFrom',
                        platformUserIdField: 'idUserTo'
                    })

                    // 根据日期筛选数据
                    let filteredRecords = recordsWithUserInfo
                    if (this.dateRange && this.dateRange.length === 2) {
                        const [startDate, endDate] = this.dateRange
                        filteredRecords = recordsWithUserInfo.filter(record => {
                            const recordDate = new Date(record.dateSent)
                            const rangeStartDate = startDate ? new Date(startDate) : null
                            const rangeEndDate = endDate ? new Date(endDate) : null

                            if (rangeStartDate && recordDate < rangeStartDate) return false
                            if (rangeEndDate && recordDate > rangeEndDate) return false
                            return true
                        })
                    }

                    // 计算统计数据
                    this.analysisData.totalGifts = filteredRecords.length
                    this.analysisData.totalCredits = filteredRecords.reduce((sum, record) => sum + (record.gift?.cost || 0), 0)

                    // 统计送礼用户数（去重）
                    const uniqueUsers = new Set(filteredRecords.map(record => record.idUserFrom))
                    this.analysisData.totalUsers = uniqueUsers.size

                    this.analysisData.filteredData = filteredRecords
                } else {
                    this.resetAnalysisData()
                }
            } catch (error) {
                console.error('获取礼物统计数据失败:', error)
                this.$message.error('获取礼物统计数据失败')
                this.resetAnalysisData()
            } finally {
                this.analysisLoading = false
            }
        },

        // 重置分析数据
        resetAnalysisData() {
            this.analysisData = {
                totalGifts: 0,
                totalCredits: 0,
                totalUsers: 0,
                filteredData: []
            }
        },

        // 格式化礼物时间
        formatGiftTime(timestamp) {
            if (!timestamp) return ''
            const date = new Date(timestamp)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        },

        // 将日期转换为ISO格式
        formatDateToISO(dateString) {
            if (!dateString) return null
            return new Date(dateString).toISOString()
        },

        // 将日期转换为ISO格式（结束日期设置为当天23:59:59）
        formatEndDateToISO(dateString) {
            if (!dateString) return null
            return new Date(dateString + 'T23:59:59.999Z').toISOString()
        },

        // 打开邮件/聊天会话
        toChat(record, messageType) {
            console.log('打开会话:', record, messageType);
            // 构建用户信息对象，包含必要的字段
            const userData = {
                idInterlocutor: record.idUserFrom,
                userId: record.idUserFrom,
                platformUserId: this.selectedUser.id,
                platformUserDetail: {
                    id: this.selectedUser.id,
                    avatar_large: this.selectedUser.avatar_large,
                    avatar_small: this.selectedUser.avatar_small,
                    name: this.selectedUser.name,
                },
                userDetail: {
                    id: record.idUserFrom,
                    avatar_small: record.userDetail?.avatar_small,
                    avatar_large: record.userDetail?.avatar_large,
                    name: record.userDetail?.name || '未知用户',
                    isVip: record.userDetail?.isVip || false,
                    isUnmanagedVip: record.userDetail?.isUnmanagedVip || false,
                    is_online: record.userDetail?.is_online || false,
                },
                messagesLeft: 10, // 默认消息数量
            };
            this.$router.push({
                path: '/talkytimes/message',
                query: {
                    action: messageType === 'email' ? 'startEmail' : 'startChat',
                    userData: JSON.stringify(userData)
                }
            });
        }
    },

    created() {
        // 移除 getUserList 调用，让 UserListSidebar 组件自动获取数据

        // 设置默认日期范围（最近30天）
        const endDate = new Date()
        const startDate = new Date()
        startDate.setDate(startDate.getDate() - 30)
        this.dateRange = [
            startDate.toISOString().split('T')[0],
            endDate.toISOString().split('T')[0]
        ]
    },
    computed: {
        // 获取用户列表，与 UserListSidebar 组件使用相同的数据源
        userList() {
            return this.$store.state.accountList.accountList || [];
        }
    },
    watch: {
        // 监听用户列表变化，当有数据时自动选择第一个用户
        userList: {
            handler(newUserList) {
                if (newUserList.length > 0 && !this.selectedUser) {
                    console.log('GiftRecord page - Auto selecting first user:', newUserList[0]);
                    this.selectUser(newUserList[0]);
                }
            },
            immediate: true
        }
    },


}
</script>

<style lang="scss" scoped>
.gift-record-page {
    background-color: #f5f7fa;
    height: calc(100vh - 56px);

    .user-item {
        background-color: #fff;
        border: 1px solid #e4e7ed;

        &:hover {
            border-color: #2929c7;
            box-shadow: 0 2px 8px rgba(41, 41, 199, 0.15);
        }

        &.user-item-active {
            border-color: #2929c7;
            background-color: #f0f8ff;
            box-shadow: 0 2px 8px rgba(41, 41, 199, 0.15);
        }
    }

    .gift-record-section {
        height: calc(100% - 56px);
    }

    .gift-record-list {
        height: calc(100% - 50px);
    }

    // 礼物卡片样式
    .gift-cards-container {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 15px;
        padding: 10px 0;
    }

    .gift-card {
        transition: all 0.3s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

        &:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            transform: translateY(-2px);
        }

        .card-header {
            padding-bottom: 15px;

            .sender-info img {
                border: 2px solid #f0f0f0;
            }
        }

        .gift-display {
            border-radius: 6px;
            margin: 15px 0;

            img {
                object-fit: contain;
                background-color: white;
                border-radius: 4px;
                padding: 10px;
            }
        }

        .gift-message {
            font-style: italic;
        }
    }

    .stat-card {
        transition: all 0.3s ease;

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(41, 41, 199, 0.15);
        }
    }

    .section-header {
        // tab组件自带边框，移除原有边框样式
    }

    // Tab样式 - 只设置平分宽度
    .gift-record-tabs {
        :deep(.el-tabs__nav) {
            width: 100%;
            display: flex;
        }

        :deep(.el-tabs__item) {
            flex: 1; // 让两个tab平分宽度
            text-align: center;
        }

        .card-actions {
            .action-icon {
                cursor: pointer;
                transition: all 0.3s ease;
                opacity: 0.7;

                &:hover {
                    opacity: 1;
                    transform: scale(1.1);
                }
            }
        }
    }

    .empty-container,
    .loading-container {
        color: #999;

        i {
            opacity: 0.5;
        }
    }

    .filter-section {
        border: 1px solid #e4e7ed;

        :deep(.el-date-editor) {
            width: 100%;

            .el-input__inner {
                border: 1px solid #dcdfe6;
                border-radius: 4px;

                &:hover {
                    border-color: #c0c4cc;
                }

                &:focus {
                    border-color: #2929c7;
                }
            }
        }
    }

    :deep(.el-table) {
        .el-table__header {
            th {
                background-color: #f0f8ff !important;
                color: #333 !important;
                font-weight: 600;
            }
        }

        .el-table__row {
            &:hover {
                background-color: #f8f9ff;
            }
        }
    }

    :deep(.el-button) {
        &.el-button--primary {
            background-color: #2929c7;
            border-color: #2929c7;

            &:hover {
                background-color: #1a1a99;
                border-color: #1a1a99;
            }
        }
    }
}
</style>